export * from './customer-add.component';
export * from './customer-add.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-add/index.ts